import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import { makeStyles } from "@material-ui/styles";
import styled from "styled-components";
import PulseLoader from "react-spinners/PulseLoader";
import { prepare_certification_data } from "../../services/CertificationsAPI";

const theme = localStorage.getItem("brandColor");

const useStyles = makeStyles({
  root: {
    "& .super-app-theme--cell": {
      backgroundColor: "rgba(224, 183, 60, 0.55)",
      color: "#1a3e72",
      fontWeight: "600",
    },
    "& .super-app.negative": {
      backgroundColor: "rgba(157, 255, 118, 0.49)",
      color: "#1a3e72",
      fontWeight: "600",
    },
    "& .super-app.positive": {      
      border: "1px solid #ff8c24",
      color: "#1a3e72",
      fontWeight: "600",
    },
    "& .super-app-theme--header": {
      color: "#FFFFFF",
      fontWeight: "600",
    },
  },
});

const StyledButton = styled.button`
    background: ${theme};
    width: 200px;
    border-radius: 30px;
    height: 45px;
    text-align: center;
    color: white;
    font-size: 16px !important;
    font-weight: 500;
    border-color: none;
    border: none;
    margin-top: 25px;
    padding: 5px 10px;
`;

const CertificationDashboard = () => {
    const classes = useStyles();
    const history = useHistory();    
    let [loading, setloading] = useState(true)
    let [eligiblity, setEligiblity] = useState(true)
    const [overallRiskScoreData, setOverallRiskScoreData] = useState([]);
    const [uniqueTopicsCompletedData, setuniqueTopicsCompletedData] = useState([]);
    const [completedQuestionnairesData, setCompletedQuestionnairesData] = useState([]);        

    useEffect(() => {       
        prepareInitialData() 
    }, []);

    const prepareInitialData = async () => {
        let result = await prepare_certification_data({customer_id: localStorage.getItem('customerid')})
        if(result.data.code === 200){
            console.log(result.data.overall_risk_fil_data);
            setEligiblity(true)            
            setloading(false);
            setOverallRiskScoreData([result.data.overall_risk_fil_data]);
            setuniqueTopicsCompletedData(result.data.unique_topics_completed_data);
            setCompletedQuestionnairesData(result.data.topics_completed_in_topic_group)            
        } else {
            setEligiblity(false)
            setloading(false);
        }   
    }

    const overallRiskScoreColumns = [
        {
            field: "topiccount",
            headerName: "Total Topics",
            flex: 1,
            align: "center",
            headerAlign: "center",
            headerClassName: "super-app-theme--header",
        },
        {
            field: "loccount",
            headerName: "Total Locations",
            flex: 1,
            align: "center",
            headerAlign: "center",
            headerClassName: "super-app-theme--header"          
        },       
        {
            field: "avefirstscore",
            headerName: "Ave First Risk Score",
            flex: 1,
            align: "center",
            headerAlign: "center",
            headerClassName: "super-app-theme--header"          
        }, 
        {
            field: "avelatestscore",
            headerName: "Ave Latest Risk Score",
            flex: 1,
            align: "center",
            headerAlign: "center",
            headerClassName: "super-app-theme--header"          
        },
        {
            field: "avepctchange",
            headerName: "% Increase (Decrease)",
            flex: 1,
            renderCell: (params) => {
                return (                    
                    <div>                        
                        {!isNaN(+params.value) && (+params.value < 0) 
                        ? `(${Math.abs(params.value)})`
                        : `${params.value}`}
                    </div>
                );
            },
            align: "center",
            headerAlign: "center",
            headerClassName: "super-app-theme--header",             
        },
        {
            field: "averiskchange",
            headerName: "Overall Risk Change",
            flex: 1,
            align: "center",
            headerAlign: "center",
            headerClassName: "super-app-theme--header"
        }        
    ];

    const uniqueTopicsCompletedColumns = [
        {
            field: "periodyear",
            headerName: "Calendar Year",
            flex: 1,
            align: "center",
            headerAlign: "center",
            headerClassName: "super-app-theme--header",
        },
        {
            field: "cum_tlpcount",
            headerName: "Topics Retaken",
            flex: 1,
            align: "center",
            headerAlign: "center",
            headerClassName: "super-app-theme--header",
        },
        {
            field: "certtier",
            headerName: "Cert Tier",
            flex: 1,
            align: "center",
            headerAlign: "center",
            headerClassName: "super-app-theme--header",
        },
    ]

    const completedQuestionnairesColumns = [
        {
            field: "topgrpdesc",
            headerName: "Topic Group",
            flex: 1,
            align: "left",
            headerAlign: "center",
            headerClassName: "super-app-theme--header",
        },
        {
            field: "availtopics",
            headerName: "Available",
            flex: 0.3,
            align: "center",
            headerAlign: "center",
            headerClassName: "super-app-theme--header",
        },
        {
            field: "cnttopcompl",
            headerName: "Completed",
            flex: 0.3,
            align: "center",
            headerAlign: "center",
            headerClassName: "super-app-theme--header",
        },
        {
            field: "pctcompl",
            headerName: "% Completed",
            flex: 0.3,
            align: "center",
            headerAlign: "center",
            headerClassName: "super-app-theme--header",
        }
    ]
    
    return (
        loading ? 
        ( 
            <div style={{height: 'calc(100vh - 66px)'}} className="d-flex justify-content-center align-items-center">
                <PulseLoader size={10} color={theme} />
            </div> 
        ) 
        : 
        <>
            <div className="container">
                <div className="text-center">
                    <StyledButton
                        onClick={() => {
                            history.push("/Extquestion2");
                        }}
                    >
                    Exit
                    </StyledButton>
                </div>
                <div>                        
                    <h1 className="text-center" style={{ paddingTop: "2%" , paddingBottom: "2%"}}>Certification Dashboard</h1>
                </div>
                { eligiblity ? (
                    <>                        
                        <div className="mt-4">
                            <h4 className="text-center">Change in Overall Risk Score</h4>
                            <div style={{ height: "auto", width: "100%" }} className={classes.root}>
                                <DataGrid
                                    sx={{
                                        ".MuiDataGrid-columnHeaders": {
                                            backgroundColor: theme,
                                        },
                                        "&.MuiDataGrid-root": {
                                            border: "none",
                                        },
                                    }}
                                    autoHeight                            
                                    rows={overallRiskScoreData}
                                    onRowClick={() => {                                    
                                        history.push(`/change_in_topic_risk_score/`);
                                    }}
                                    getRowId={(r) => r.id}
                                    id="_id"                     
                                    columns={overallRiskScoreColumns} 
                                    hideFooterPagination={true}                       
                                />
                            </div>
                        </div>
                        <div className="mt-4">
                            <h4 className="text-center">Number of Unique Topics Completed and Repeated</h4>
                            <div style={{ height: "auto", width: "50%", margin: 'auto' }} className={classes.root}>
                                <DataGrid
                                    sx={{
                                        ".MuiDataGrid-columnHeaders": {
                                            backgroundColor: theme,
                                        },
                                        "&.MuiDataGrid-root": {
                                            border: "none",
                                        },
                                    }}
                                    autoHeight                            
                                    rows={uniqueTopicsCompletedData}
                                    getRowId={(r) => r.id}
                                    id="_id"   
                                    onRowClick={(params) => {                                    
                                        history.push(`/topic_completed_and_repeated/${params.row.periodyear}`);
                                    }}                   
                                    columns={uniqueTopicsCompletedColumns} 
                                    hideFooterPagination={true}                       
                                />
                            </div>
                        </div>
                        <div className="mt-4">
                            <h4 className="text-center">Topic Group Questionnaires Completed</h4>
                            <div style={{ height: "auto", width: "75%", margin: 'auto'}} className={classes.root}>
                                <DataGrid
                                    sx={{
                                        ".MuiDataGrid-columnHeaders": {
                                            backgroundColor: theme,
                                        },
                                        "&.MuiDataGrid-root": {
                                            border: "none",
                                        },
                                    }}
                                    autoHeight                            
                                    rows={completedQuestionnairesData}
                                    getRowId={(r) => r.topgrpcode}
                                    id="_id"      
                                    onRowClick={(params) => {                                    
                                        history.push(`/topics_completed/${params.row.topgrpcode}`);
                                    }}               
                                    columns={completedQuestionnairesColumns} 
                                    hideFooterPagination={true}                       
                                />
                            </div>
                        </div>  
                    </> 
                ) :  
                (
                <>
                    <div style={{ height: '50vh'}} className="d-flex align-items-center justify-content-center">
                        <div>
                            <h5>There is insufficient data to meet certification requirements.</h5>
                        </div>
                    </div>
                </>
                )
                }
            </div>
        </>                    
            
    )
}


export default CertificationDashboard